import { Link, Outlet } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { careersAPI } from "../../services/api";

export default function CareersLayout() {
  const { t } = useTranslation();
  const { data: companyInfo } = useQuery({
    queryKey: ["careers-info"],
    queryFn: () => careersAPI.getInfo().then((r) => r.data),
    staleTime: 300000,
  });

  const companyName = companyInfo?.company_name || t("careers.layout.companyFallback");

  return (
    <div style={{ backgroundColor: "var(--lm-canvas)", minHeight: "100vh", color: "var(--lm-ink)", fontFamily: "Inter, system-ui, sans-serif" }}>
      {/* Top nav */}
      <nav
        className="sticky top-0 z-10 flex items-center justify-between px-6 h-14"
        style={{
          backgroundColor: "rgba(1,1,2,0.78)",
          backdropFilter: "blur(12px)",
          borderBottom: "1px solid var(--lm-border)",
        }}
      >
        <Link to="/careers" className="flex items-center gap-2 no-underline">
          {companyInfo?.logo_url ? (
            <img
              src={companyInfo.logo_url}
              alt={companyName}
              className="h-6 w-auto object-contain"
            />
          ) : (
            <span className="text-sm font-semibold tracking-tight" style={{ color: "var(--lm-ink)" }}>
              {companyName}
            </span>
          )}
          <span
            className="text-xs px-2 py-0.5 rounded-full"
            style={{ color: "var(--lm-ink-3)", backgroundColor: "var(--lm-s2)", border: "1px solid var(--lm-border)" }}
          >
            {t("careers.layout.badge")}
          </span>
        </Link>
        <Link
          to="/careers/track"
          className="text-xs font-medium transition-colors no-underline"
          style={{ color: "var(--lm-ink-2)" }}
          onMouseEnter={(e) => { e.currentTarget.style.color = "var(--lm-ink)"; }}
          onMouseLeave={(e) => { e.currentTarget.style.color = "var(--lm-ink-2)"; }}
        >
          {t("careers.layout.track")}
        </Link>
      </nav>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 py-12">
        <Outlet context={{ companyInfo, companyName }} />
      </div>

      {/* Footer */}
      <footer
        className="border-t mt-24 px-6 py-8 flex items-center justify-between"
        style={{ borderColor: "var(--lm-border)" }}
      >
        <span className="text-xs" style={{ color: "var(--lm-ink-3)" }}>
          {companyInfo?.website ? (
            <a href={companyInfo.website} target="_blank" rel="noopener noreferrer" style={{ color: "var(--lm-ink-3)", textDecoration: "none" }}>
              {companyName}
            </a>
          ) : (
            companyName
          )}
        </span>
        <div className="flex gap-4 text-xs" style={{ color: "var(--lm-ink-3)" }}>
          <a href="/privacy" style={{ color: "inherit" }}>{t("careers.layout.privacy")}</a>
          <a href="/terms" style={{ color: "inherit" }}>{t("careers.layout.terms")}</a>
          <span>
            {t("careers.layout.poweredBy")} <span style={{ color: "#5e6ad2" }}>mawered</span>
          </span>
        </div>
      </footer>
    </div>
  );
}
